import HttpUtils from "../../../utils/http.utils";

export default class ContactAPI {
  public static postReportIssue(body: FormData): Promise<void> {
    return HttpUtils.post("/contact/report-issue", body);
  }
}
